const parseFacetNameForAttribute = (facetName) => {
  return facetName
    .replace(/"/g, '')
    .replace(/\s/g, '-');
}

export {
  parseFacetNameForAttribute
}